import { useQuery } from '@tanstack/react-query';

import { MembershipIdentifier } from 'src/features/membership/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/memberships/membership/:membershipId/identifiers/`;

type QueryFnType = typeof queryFn;
interface DTO extends ListDTO {
    parkingId: string;
    membershipId: string;
}
const queryFn = ({ parkingId, membershipId, ...params }: DTO): Promise<ListResponseSmartParkAPI<MembershipIdentifier>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, membershipId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_IDENTIFIERS_RESOURCE, useQueryHook as useListIdentifiers };
